const positionCarouselNav = () => {
  const carouselDiv = document.querySelectorAll(
    '.wp-block-deepsea-dynamic-card-carousel, .wp-block-deepsea-custom-card-carousel',
  );

  if (carouselDiv.length > 0) {
    const tableMatchMedia = window.matchMedia('(min-width: 992px)');

    carouselDiv.forEach((carousel) => {
      const carouselHeight = carousel.offsetHeight;
      const prevButton = carousel.querySelector('.card-carousel-prev');
      const nextButton = carousel.querySelector('.card-carousel-next');

      if (!tableMatchMedia.matches) {
        prevButton.style.marginTop = null;
        nextButton.style.marginTop = null;

        return;
      }

      if (carouselHeight > 700 && prevButton && nextButton) {
        prevButton.style.marginTop = `-${carouselHeight}px`;
        nextButton.style.marginTop = `-${carouselHeight}px`;
      }
    });
  }
};

document.addEventListener('DOMContentLoaded', positionCarouselNav);
window.addEventListener('resize', positionCarouselNav);
